module.exports = __webpack_public_path__ + "img/dollar-icon.27e8d2d2.png";